import { Component,Input,OnInit,OnChanges} from '@angular/core';
import { DataService } from 'src/app/services/data.service';
declare var $:any

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent{
  @Input() menuLinks:any;
  @Input() hamburgerMenu:any;
 
  @Input() branch_locator:string='';
  @Input() tollfree_number:string='';
  @Input() tollfree_2:string='';
  @Input() display_tollfree_sec!:boolean
  @Input() request_callback:string='';
  
   constructor() {}
 
   ngOnChanges(){
     
    //alert(this.tollfree_2);
   }
   ngOnInit(): void {
    this.slidelinks(); 
   }

   slidelinks() {
    $(document).ready( () => {
      $(".sidebar-menu .has-children > a").on("click",  (e:any) => {
        e.preventDefault();
        $(this).parent().toggleClass('active').siblings().removeClass('active');
        $(this).next('.children-wrapper').slideToggle(350).parent().siblings().find('.children-wrapper').slideUp(350);
        e.stopPropagation();
      });
    });
  }
 
  
 



   registerGANav(menu:any){
    
  }

  registerGANav1(menu:any){
   
  }

  registerGALogo(){
    
  }
 
 }
 


